export const getDate = () => {
  const date = String(new Date()).split(' ');

  return date[0] + date[1] + date[2] + date[3];
};

export const formatDuration = (seconds: number): string => {
  if (seconds <= 0) {
    return '-';
  }

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);

  const formattedHours = hours > 0 ? `${hours}h ` : '';
  const formattedMinutes = minutes > 0 ? `${minutes}m ` : '';

  return formattedHours + formattedMinutes;
};

export const getPercentDuration = (duration: string, total: string) => {
  const durationInt = Number.parseInt(duration, 10);
  const totalInt = Number.parseInt(total, 10);

  if (Number.isNaN(durationInt) || Number.isNaN(totalInt) || totalInt === 0) {
    return 0;
  }

  return Math.floor((durationInt / totalInt) * 100);
};

export const formatToPST = (utcDateStr: string | null | undefined): string | null => {
  if (!utcDateStr) {
    return null;
  }

  const date = new Date(`${utcDateStr}Z`);

  if (Number.isNaN(date.getTime())) {
    return null;
  }

  const pstDate = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/Los_Angeles',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(date);

  const [month, day, year] = pstDate.split('/');

  if (!year || !month || !day) {
    return null;
  }

  return `${year}-${month}-${day}`;
};

export const formatDate = (dateString: string | undefined | null): string | null => {
  if (!dateString) {
    return null;
  }

  const date = new Date(dateString);

  if (isNaN(date.getTime())) {
    return null;
  }

  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString()
    .padStart(2, '0');
  const year = date.getFullYear().toString();

  return `${month}/${day}/${year}`;
};


/**
 * Format ISO timestamp to a human-readable label matching the design:
 *   - < 1 hour  → "X mins ago"
 *   - same day  → "HH:MM am/pm"
 *   - otherwise → "Mon DD, YYYY  H:MM pm"
 */
export const formatTime = (iso: string): string => {
  const date = new Date(iso);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffMins = Math.floor(diffMs / 60000);

  if (diffMins < 60) {
    return `${diffMins} mins ago`;
  }

  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  if (sameDay) {
    return date.toLocaleTimeString('en-US', {
      timeZone: 'America/Los_Angeles',
      hour: 'numeric',
      minute: '2-digit'
    });
  }

  return date.toLocaleDateString('en-US', {
    timeZone: 'America/Los_Angeles',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
  });
};
